export default __webpack_public_path__ + "static/chandelier-1224248_1920-28f1b81ed7803f0d20ce6ad6a9e82779.png";